<template>
    <select class="form-control font-weight-bold" v-model="valor" @change="$emit('evento', valor)">
        <option value="">Seleccione </option>
        <option v-for="(d,index) in data" :key="index" :value="d.valor">
            {{d.valor }}</option>
    </select>
</template>

<script>
    export default {
        name: "SelectTrimovil",
        props: ['valor_entrada', 'tipo', 'marca'],
        data() {
            return {
                valor: '',
                data: []
            }
        },
        beforeMount() {
            setTimeout(() => {

                this.valor = this.valor_entrada;
            }, 100);

            if (this.marca == '1' || this.marca == '2') {
                    this.data = this.$store.state.dataSelectsTVS[this.tipo];
                } else {
                    this.data = this.$store.state.dataSelectsBajaj[this.tipo];
                }


        },

        watch: {

            valor_entrada(newQuestion, oldQuestion) {
                this.valor = newQuestion;

            },
            marca(newQuestion, oldQuestion) {
                if (newQuestion == '1' || newQuestion == '2') {
                    this.data = this.$store.state.dataSelectsTVS[this.tipo];
                } else {
                    this.data = this.$store.state.dataSelectsBajaj[this.tipo];
                }

            },
        }

    }
</script>